import * as React from 'react';
import styled from 'styled-components';
import { FormHelperText } from '@mui/material';

const StyledLabel = styled(FormHelperText)({
  fontStyle: 'normal'
});

export const ProtrakLabel = ({ text, style }) => {
  return <StyledLabel sx={style}>{text}</StyledLabel>;
};
